import { useEffect, useState } from 'react';

declare global {
  interface Window {
    Telegram?: {
      WebApp: {
        ready: () => void;
        expand: () => void;
        close: () => void;
        initData: string;
        initDataUnsafe: {
          user?: {
            id: number;
            first_name: string;
            last_name?: string;
            username?: string;
            language_code?: string;
          };
          auth_date: number;
          hash: string;
        };
        MainButton: {
          text: string;
          color: string;
          textColor: string;
          isVisible: boolean;
          isActive: boolean;
          setText: (text: string) => void;
          onClick: (callback: () => void) => void;
          offClick: (callback: () => void) => void;
          show: () => void;
          hide: () => void;
          enable: () => void;
          disable: () => void;
        };
        themeParams: {
          bg_color?: string;
          text_color?: string;
          hint_color?: string;
          link_color?: string;
          button_color?: string;
          button_text_color?: string;
          secondary_bg_color?: string;
        };
      };
    };
  }
}

interface TelegramUser {
  id: number;
  first_name: string;
  last_name?: string;
  username?: string;
  language_code?: string;
}


export function useTelegram() {
  const [tg, setTg] = useState<any>(null);
  const [user, setUser] = useState<TelegramUser | null>(null);

  useEffect(() => {
    console.log('🔍 useTelegram useEffect triggered');
    console.log('🔍 window.Telegram?.WebApp:', window.Telegram?.WebApp);
    console.log('🔍 import.meta.env.DEV:', import.meta.env.DEV);
    
    // В режиме разработки всегда используем заглушку
    if (import.meta.env.DEV) {
      console.log('🔧 Development mode: Using Telegram WebApp stub');
      
      const mockTg = {
        ready: () => console.log('📱 Telegram WebApp ready (mock)'),
        expand: () => console.log('📱 Telegram WebApp expand (mock)'),
        close: () => console.log('📱 Telegram WebApp close (mock)'),
        MainButton: {
          text: '',
          isVisible: false,
          isActive: true,
          setText: (text: string) => console.log(`📱 MainButton text set: ${text}`),
          onClick: (_callback: () => void) => console.log('📱 MainButton onClick set'),
          offClick: (_callback: () => void) => console.log('📱 MainButton offClick'),
          show: () => console.log('📱 MainButton show'),
          hide: () => console.log('📱 MainButton hide'),
          enable: () => console.log('📱 MainButton enable'),
          disable: () => console.log('📱 MainButton disable'),
        }
      };
      
      console.log('🔧 Setting mock Telegram WebApp');
      setTg(mockTg);
      
      const testUser = { 
        id: 123456789, 
        first_name: 'Test User',
        username: 'testuser'
      };
      console.log('🔧 Setting test user:', testUser);
      setUser(testUser);
      
    } else if (window.Telegram?.WebApp) {
      console.log('✅ Real Telegram WebApp detected');
      const webapp = window.Telegram.WebApp;
      setTg(webapp);
      
      if (webapp.initDataUnsafe.user) {
        console.log('✅ Telegram user found:', webapp.initDataUnsafe.user);
        setUser(webapp.initDataUnsafe.user);
      } else {
        console.log('❌ No Telegram user in initDataUnsafe');
      }

      // Apply Telegram theme
      const theme = webapp.themeParams;
      if (theme) {
        const root = document.documentElement;
        if (theme.bg_color) root.style.setProperty('--tg-theme-bg-color', theme.bg_color);
        if (theme.text_color) root.style.setProperty('--tg-theme-text-color', theme.text_color);
        if (theme.hint_color) root.style.setProperty('--tg-theme-hint-color', theme.hint_color);
        if (theme.link_color) root.style.setProperty('--tg-theme-link-color', theme.link_color);
        if (theme.button_color) root.style.setProperty('--tg-theme-button-color', theme.button_color);
        if (theme.button_text_color) root.style.setProperty('--tg-theme-button-text-color', theme.button_text_color);
        if (theme.secondary_bg_color) root.style.setProperty('--tg-theme-secondary-bg-color', theme.secondary_bg_color);
      }
    } else {
      console.log('❌ No Telegram WebApp available');
    }
  }, []);

  return { tg, user };
}